<template>
<div>
  <section class="content-header">
    <h1>{{$t('language.list')}}</h1>
  </section>

  <section class="content">
    <div class="box box-primary">
      <div class="box-header with-border">
        <router-link :to="{ name: 'LanguageCreate' }" class="btn btn-primary pull-right">{{$t('language.add')}}</router-link>
      </div>
      <div class="box-body">
        <item-list-errors :entity="'language'"></item-list-errors>

        <api-table
                :entity="'Language'"
                :route="'languages'"
                :path="'language'"
                :filterable="filterable"
                :sortable="sortable"
                :columns="columns"
        ></api-table>
      </div>
    </div>
  </section>
</div>
</template>

<script>
import ItemListErrors from '../layout/errors/ItemListErrors'
import ApiTable from '../ApiTable'

export default {
  components: {ItemListErrors, ApiTable},
  data: function () {
    return {
      columns: ['id', 'name', 'code', 'actions'],
      filterable: ['id', 'name', 'code'],
      sortable: ['id', 'name', 'code'],
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/language/List.vue